<div class="hub-container">
  <h1 class="hub-title">BI Reports</h1>
  <p class="hub-subtitle">Select a report below to view its dashboard.</p>

  @if (isLoading$ | async) {
    <div class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="loading-text">Loading reports...</p>
    </div>
  } @else {
    <div class="reports-grid">
      @for (tile of (hubTiles$ | async); track (tile.kind === 'report' ? tile.report.reportId : tile.label)) {
        <div class="report-card">
          <div class="card-header">
            <div class="icon-container">
              <mat-icon>{{ tile.kind === 'category' ? tile.icon : 'bar_chart' }}</mat-icon>
            </div>
            <span class="report-title">{{ tile.kind === 'category' ? tile.label : tile.report.reportName }}</span>
          </div>
          <button mat-raised-button color="primary" (click)="openTile(tile)">
            {{ tile.kind === 'category' ? 'View Reports' : 'Open Dashboard' }}
          </button>
        </div>
      }
    </div>
  }
</div>
